import React, { forwardRef } from 'react'
import { Dimensions, StyleSheet } from 'react-native'
import PropTypes from 'prop-types'
import { Colors } from '@vfgroup-oneplatform/foundation/Components/Themes'

import VFCodeInput from '@vfgroup-oneplatform/login/Screens/VerifyCode/VFCodeInput'

import styles from './VerifyCode.Styles'

const { width } = Dimensions.get('screen')
const size = Math.floor((width - 100) / 4)


function getCellStyle(isError, isFocused) {
  const stylesArr = [styles.codeInputText]
  if (isError) {
    stylesArr.push({ borderColor: Colors.vfRed })
  }

  if (isFocused) {
    stylesArr.push({
      borderTopWidth: 2.1,
      borderBottomWidth: 2.1,
      borderLeftWidth: 2.1,
      borderRightWidth: 2.1,
    })
  }
  return StyleSheet.flatten(stylesArr)
}

function VerifyCode({
  coderRef,
  codeLength,
  keyboardType,
  handlerOnFulfill,
  theme,
}) {

  return (
    <VFCodeInput
      ref={(c) => { coderRef.current = c }}
      size={size}
      codeLength={codeLength}
      variant="border-box"
      colors={theme.colors}
      keyboardType={keyboardType}
      onFulfill={handlerOnFulfill}
      maskSymbol="•"
    />
  )
}

VerifyCode.propTypes = {
  coderRef: PropTypes.object,
  codeLength: PropTypes.number,
  keyboardType: PropTypes.string,
  handlerOnFulfill: PropTypes.func,
}

export { getCellStyle }

export default forwardRef(VerifyCode)
